import { FC, useRef } from 'react';
import { IonNav } from '@ionic/react';
import { AllieNavProps } from './Nav.types';
import { NavigationProvider, useNavigationContext } from './NavContext';

export const AllieNav: FC<AllieNavProps> = (props: AllieNavProps) => {
  const navRef = useRef<HTMLIonNavElement>(null);
  return (
    <NavigationProvider navRef={navRef}>
      <IonNav {...props} ref={navRef} />
    </NavigationProvider>
  );
};

export { useNavigationContext };
